import { post } from './BackendService';

export interface AuthResult {
  readonly email: string;
  readonly token: string;
  readonly expires: string;
}

export const googleLogin = async (token: string): Promise<AuthResult> => {
  return post<AuthResult>('/login/google', { token });
};
